import moment from 'moment';
const Months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
export const EngagementCSV = (
    conversationStatsData,
    conversationNightStatsData,
    fromDate, toDate,
    chattimeStatsData,
    chattimeNightStatsData,
    visitorStatsData, avatarclickdata
) => {
    var tablePrint = [
        {
            r1: "Digital Assistant Engagement", r2: "", r3: "", r4: "", r5: "", r6: "", r7: ""
        },
        {},
        {
            r1: "Start Date :" + fromDate, r2: "", r3: "", r4: "", r5: "", r6: "", r7: ""
        },
        {
            r1: "End Date :" + toDate, r2: "", r3: "", r4: "", r5: "", r6: "", r7: ""
        },
        {},
        {
            r1: "Date",
            r2: "Unique Visitors",
            r3: "Total Avatar Clicks",
            r4: "Total Conversations",
            r5: "Conversation at Nights",
            r6: "Engagement (in Minutes)",
            r7: "Engagement (in Minutes) Nights"
        },
    ];
    if (conversationStatsData.length > 0 && conversationNightStatsData.length > 0) {
        conversationStatsData.map(elem => {
            var date;
            var uniqueVisitor;
            var avatarclick;
            var nightCon;
            var conversationtime;
            var conversationTimenight;
            if (elem.date !== undefined) {
                date = moment(elem.date).format('lll');
                uniqueVisitor = visitorStatsData.filter((x) => x.date === elem.date);
                avatarclick = 0;
                avatarclickdata.filter(f=> f.date == elem.date).map((x) => avatarclick += x.totalAvatarClicks);                
                nightCon = conversationNightStatsData.filter((slug) => slug.date === elem.date);
                conversationtime = chattimeStatsData.filter((slug) => slug.date === elem.date);
                conversationTimenight = chattimeNightStatsData.filter((slug) => slug.date === elem.date);
            } else {
                date = Months.at(elem.month - 1);
                uniqueVisitor = visitorStatsData.filter((x) => x.month === elem.month);
                avatarclick = 0;
                avatarclickdata.filter(f=>moment(f.date).format('M') == elem.month).map((x) => avatarclick += x.totalAvatarClicks);                
                nightCon = conversationNightStatsData.filter((slug) => slug.month === elem.month);
                conversationtime = chattimeStatsData.filter((slug) => slug.month === elem.month);
                conversationTimenight = chattimeNightStatsData.filter((slug) => slug.month === elem.month);
            }
            tablePrint.push({
                r1: date,
                r2: uniqueVisitor.length > 0 ? uniqueVisitor[0].count : 0,
                r3: avatarclick,
                r4: elem.count,
                r5: nightCon.length > 0 ? nightCon[0].count : 0,
                r6: conversationtime.length > 0 ? conversationtime[0].hours : 0,
                r7: conversationTimenight.length > 0 ? conversationTimenight[0].hours : 0,
            })
        });
    }
    return tablePrint;

}
